import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Component, OnDestroy} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginModalComponent} from '../login-modal/login-modal.component';

@Component({
  selector: 'app-modal-container',
  template: ''
})
export class ModalContainerComponent implements OnDestroy {
  destroy = new Subject<any>();
  currentDialog = null;

  constructor(private modalService: NgbModal,
              route: ActivatedRoute,
              router: Router
  ) {
    route.params.pipe(takeUntil(this.destroy)).subscribe(params => {

      // When router navigates on this component is takes the params
      // and opens up the login modal
      this.currentDialog = this.modalService.open(LoginModalComponent, {
        scrollable: true,
        windowClass: 'modal-login',
        size: 'lg',
        centered: true,
      });
      this.currentDialog.componentInstance.type = params.type;

      // Go back to home page after the login modal is closed
      this.currentDialog.result.then(result => {
        router.navigateByUrl('/');
      }, reason => {
        router.navigateByUrl('/');
      });
    });
  }

  ngOnDestroy(): void {
    // this.destroy.next();
  }
}
